import ItineraryEventItem from 'components/itineraryEventItem/ItineraryEventItem';
import EventsFilteringDropdown from 'components/eventsFilteringDropdown/EventsFilteringDropdown';
import { ItineraryEvent } from 'core/graphql/types';
import useAppDispatch from 'core/hooks/useAppDispatch';
import { setClickedDeliveryId } from 'pages/itinerary/ItinerarySlice';
import { useMap } from 'react-map-gl';

export interface EventsListProps {
  events: ItineraryEvent[];
  filterHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedFilters: string[];
}

const EventsList = ({
  events,
  selectedFilters,
  filterHandler,
}: EventsListProps) => {
  const dispatch = useAppDispatch();
  const { itineraryDetailsMap } = useMap();
  const onSelectEvent = (event: ItineraryEvent) => {
    dispatch(setClickedDeliveryId(event.id));
    if (event.latitude && event.longitude) {
      itineraryDetailsMap?.flyTo({
        center: [event.longitude, event.latitude],
        duration: 1500,
      });
    }
  };
  return (
    <>
      <div className=" mt-4 flex items-center justify-between">
        <div className="min-w-0 flex-1">
          <span>Events</span>
          <span className="ml-2 rounded-lg bg-gray px-2 dark:bg-design-secondary-black">
            {events.length ?? 0}
          </span>
        </div>
        <div className="shrink-0">
          <EventsFilteringDropdown
            filterHandler={filterHandler}
            selectedFilters={selectedFilters}
          />
        </div>
      </div>
      <div>
        {events.map((event) => (
          <ItineraryEventItem
            key={event.id}
            event={event}
            onEventClick={onSelectEvent}
          />
        ))}
      </div>
    </>
  );
};

export default EventsList;
